import React from 'react';
import '../styles/DownloadAppSection.css';

function DownloadAppSection({ title, copy, imageSrc, images, imageOn, children }) {
  const hasGrid = images && images.length === 4;

  return (
    <section className={`download-app-section ${imageOn === 'left' ? 'image-left' : ''}`}>
      <div className="download-app-content">
        <h2 className="download-app-title">{title}</h2>
        <p className="download-app-copy">{copy}</p>
        <div className="download-app-buttons">{children}</div>
      </div>
      <div className={`download-app-image ${hasGrid ? 'download-app-image-grid' : ''}`}>
        {hasGrid ? (
          images.map((src, i) => (
            <img key={i} src={src} alt={`${title} screenshot ${i + 1}`} />
          ))
        ) : (
          <img src={imageSrc} alt={title} />
        )}
      </div>
    </section>
  );
}

export default DownloadAppSection;
